import { useSelector } from 'react-redux';
import { RootState } from '../services/redux';

export const useRole = () => {
  const { role } = useSelector((redux: RootState) => redux.authReducer);

  const isVolunteerIntructor = role === 'Instructor' || role === 'Volunteer';
  const isIndividualCorporate = role === 'Individual' || role === 'Corporate';
  const isIndividual = role === 'Individual';
  const isVolunteer = role === 'Volunteer';

  return {
    isVolunteerIntructor,
    isIndividualCorporate,
    isIndividual,
    isVolunteer,
  };
};
